<template>
  <div class="infoCard">
    <span>
      <i class="h4 budicon-alert-sign" />
    </span>
    <slot></slot>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'infoCard',
});
</script>

<style lang="scss" scoped>
.infoCard {
  display: flex;
  gap: 0rem 1rem;
  align-items: center;
  padding: 1rem;
  background: #ecf8f2;
  border: 1px solid $gray-200;
}
</style>
